export const API_BASE_URL = "https://eparticipation.gov.lk/back_end";
export const API_IMG_URL = "https://eparticipation.gov.lk//epart-admin";
